import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

barba.use(barbaPrefetch);

class Router {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.currentNamespace = '';
    this.pageApp = undefined;
    this.initBarba();
  }

  initBarba() {
    barba.init({
      timeout: 6000,
      debug: false,
      prevent: ({ el }) => el.dataset.barba === 'false',
      transitions: [
        {
          name: 'default',
          once: (data) => {
            this.setCurrentNamespace(data);
          },
          before: async () => {
            console.log('before');
            this.mainApp.scrollEffect.destroy();
            if (this.pageApp) {
              this.pageApp.destroy();
              this.pageApp = undefined;
            }
            window
              .$('.WhiteMaskScroll, .WhiteMask')
              .removeClass('--Leaving --Done');
            window
              .$('.fadeIn--glitch, .WhiteMaskAlready')
              .addClass('--WhiteMask');
            await this.wait(1000);
          },
          leave: async () => {
            window.menuApp.CloseMenu();
          },
          enter: () => {
            window.scrollTo(0, 0);
          },
          after: (data) => {
            console.log('afterEnter');
            this.setCurrentNamespace(data);
            if (data.next.namespace === 'home') {
              window.$('.Header__Left').addClass('--HomePosition');
            } else {
              window.$('.Header__Left').removeClass('--HomePosition --Done');
            }
            window.$('.PageTitle').addClass('fadeIn--glitch');
            setTimeout(function () {
              window.$('.MenuBg').addClass('--Loaded');
              window.$('.WhiteMask').addClass('--Leaving');
              window.$('.WhiteMaskAlready').removeClass('--WhiteMask');
            }, 1000);
          },
        },
      ],
    });

    // newPageReadyイベントを修正
    barba.hooks.after((data) => {
      // 現在のbodyクラスをクリア
      document.body.className = '';

      // 新しいページのbodyクラスを取得して適用
      const newBodyClasses = data.next.html.match(/<body class="(.*?)".*?>/);
      if (newBodyClasses && newBodyClasses[1]) {
        // クォーテーションマークをエスケープして適用
        const cleanClasses = newBodyClasses[1].replace(/"/g, '\\"');
        document.body.className = cleanClasses;
      }

      // data-wave-color属性を適用
      const waveColorMatch = data.next.html.match(/data-wave-color="(.*?)"/);
      if (waveColorMatch && waveColorMatch[1]) {
        document.body.setAttribute('data-wave-color', waveColorMatch[1]);
      } else {
        document.body.removeAttribute('data-wave-color');
      }
    });
  }

  wait(duration) {
    return new Promise((resolve) => setTimeout(resolve, duration));
  }

  setCurrentNamespace(data) {
    this.currentNamespace = data.next.namespace;
    this.mainApp.initializePage(this.currentNamespace);
  }
}

export default Router;
